import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CImg
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import usericon from "src/assets/icons/6.jpg";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LOGOUT_SUCCESS, SELECTED_THEME } from 'src/actions/actionTypes';
import cookie from 'react-cookies'
import ProfileView from 'src/views/pages/profile/ProfileView';
import { getUserName, getUserEmail } from 'src/util/miscUtil';
import { initUserProfileData } from 'src/actions/registration';
import UserFeedback from 'src/views/pages/user-feedback/UserFeedback';
import $ from 'jquery';

const TheHeaderDropdown = () => {
  const userId = useSelector(state => state.userReduser?.loginUserData?.userId)
  const theme = useSelector(state => state.userReduser?.selectedTheme)
  const history = useHistory()
  const dispatch = useDispatch()
  const [showFeedBack, setshowFeedBack] = useState(false)


  const handleNavigation = (val) => {
    setshowFeedBack(false)
    setprimaryRefModal(!primaryRefModal)
    if (val == "logOut") {
      $('body').removeAttr('id');
      dispatch({ type: LOGOUT_SUCCESS, payload: [] });
      cookie.remove("GST_USER_DATA", { path: '/' })
      cookie.remove('SELECTED_GSTIN_DETAIL', { path: '/' });
      cookie.remove('SELECTED_GSTIN_LIST', { path: '/' });
      dispatch({ type: "SELECTED_GSTIN_LIST_STORE", payload: null });
      cookie.remove('TENANT', { path: '/' })
      history.push(`/login`);
      window.location.reload();
    } else if (val == "authentication") {
      history.push(`/authentication`)
    } else if (val === "feedBack") {
      setTimeout(() => {
        setshowFeedBack(true)
      }, 0);
    } else if (val === "subscription") {
      history.push(`/subscription-plan`)
    } else if (val === "invite-user") {
      history.push(`/invite-user`)
    } else if (val === 'request-support') {
      history.push(`/request-anydesk-support`)
    }
    else {
      history.push(`/profile-settings`)
    }
  }
  useEffect(() => {
    dispatch(initUserProfileData({ "user_id": userId }));
  }, [userId])
  const [showModal, setshowModal] = useState(false)
  const [primaryRefModal, setprimaryRefModal] = useState(false)
  const [userImage, setUserImage] = useState();
  const initProfileResp = useSelector(state => state.registration?.initProfileResp)

  useEffect(() => {
    if (initProfileResp && Object.keys(initProfileResp).length > 0) {
      setUserImage(initProfileResp?.data?.profile_pic_path)
    }
  }, [initProfileResp])
  const onRefModalClose = () => {

    setprimaryRefModal(!primaryRefModal)
  }
  const onProfileClick = () => {
    // setshowModal(false)
    setshowModal(true)
  }
  const handleSupportRequest = () => {
    setprimaryRefModal(false)
    window.open('#/request-anydesk-support');

  }
  useEffect(() => {
   let theme = localStorage.getItem("SELECTED_THEME")
   handleThemeSelection(theme)
  }, [])
  const handleThemeSelection = (theme) => {
    if (theme === "dark") {
      $('body').attr("id", 'dark-theme');
    } else {
      $('body').removeAttr('id');
    }
    dispatch({
      type: SELECTED_THEME,
      payload: theme
    })
    localStorage.setItem("SELECTED_THEME", theme)
  }
  return (
    <>
      <CDropdown
        inNav
        className="c-header-nav-items mx-1"
        direction="down"
      >
        <CDropdownToggle className="c-header-nav-link" caret={false}>
          <div className="c-avatar c-av-width" onClick={() => setprimaryRefModal(!primaryRefModal)}>
            {
              userImage ? (<img src={`${userImage}`} className="c-avatar-img" />) :
                <img src={usericon} className="c-avatar-img mdb-shadow" />
            }

          </div>
        </CDropdownToggle>
        {/* <CDropdownMenu className="pt-0 border-0 mdb-shadow small-font-dropdown" placement="bottom-end">
        <CDropdownItem className="status-font" onClick={()=>handleNavigation("tallyReg")}>
          <i name="cil-bell" className="far fa-building mfe-2" /> 
          My Tally Companies 
          <CBadge color="info" className="ml-1"> 42 </CBadge>
        </CDropdownItem>
        <CDropdownItem className="status-font" onClick={()=>handleNavigation("profile")}>
          <i name="cil-bell" className="far fa-user mfe-2" /> 
           Profile Settings 
        </CDropdownItem>
        <CDropdownItem className="status-font" onClick={()=>handleNavigation("logOut")}>
        <i name="cil-bell" className="fa fa-power-off mfe-2" /> 
          Logout
        </CDropdownItem>
      </CDropdownMenu> */}
      </CDropdown>
      {/* profile modal starts */}
      {/* {showModal && <ProfileView showModal={showModal}></ProfileView>} */}
      <div className="header-dropdown-pop-inside  profile-modal right-animation">
        <CModal
          show={primaryRefModal}
          centered
          size="lg"
          onClose={() => onRefModalClose()}
          color="dark right"
        // closeOnBackdrop={false}
        >
          {/* <CModalHeader className="border-bottom-0 modal-header">
            <CModalTitle >  <button className="text-dec-none c-pointer mb-0 btn btn-link btn-xs min-font-size status-font text-danger mt-1" onClick={() => handleNavigation("logOut")}><i className="fas fa-sign-out-alt"></i> Logout</button></CModalTitle>
          </CModalHeader> */}
          <CModalBody className="text-left less-modal-bold p-0">
            <div className="modal-header border-0 dark-theme-modal-header-position">
              {theme !== "dark" && <button onClick={() => handleThemeSelection("dark")} className="btn btn-outline-dark btn-25-radius shadow-none btn-sm  font-size-10 status-font"><i className="fas fa-moon text-dark"></i> Dark Mode</button>}
              {theme === "dark" && <button onClick={() => handleThemeSelection("light")} className="btn btn-outline-primary btn-25-radius shadow-none btn-sm text-white font-size-10 status-font"><i className="far fa-sun text-white"></i> Light Mode</button>}
            </div>
            <div className="text-center">
              <div className="profile-large-image mt-3">
                {
                  userImage ? (<img src={`${userImage}`} className="c-sidebar-brand-full rounded-circle" width="75" />) :
                    <img src={usericon} className="c-sidebar-brand-full rounded-circle" width="75" />
                }
              </div>
              <div className="text-center mt-1 mb-3">
                <h6 className="bold-label text-uppercase pt-1 mb-1 text-primary overflow-elipsis">{getUserName()}</h6>
                <h6 className="status-font min-font-size overflow-elipsis mb-0">{getUserEmail()}</h6>
              </div>
              <div className="text-center pl-5 pr-5 mb-3 mt-3">
                <button className="btn btn-lg btn-dark btn-block very-light-btn dr-padding p-relative-p shadow-none bg-white status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("authentication")}><i className="fa fa-shield"></i> Authentication <i className="fas fa-angle-right profile-right-icon"></i></button>
                <button className="btn btn-lg btn-dark btn-block very-light-btn dr-padding p-relative-p shadow-none bg-white status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("profile")}><i className="fas fa-cog"></i> Profile Settings <i className="fas fa-angle-right profile-right-icon"></i></button>
                <button className="btn btn-lg btn-dark btn-block very-light-btn dr-padding p-relative-p shadow-none bg-white status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("subscription")}><i class="fas fa-hand-point-up"></i> Subscriptions <i className="fas fa-angle-right profile-right-icon"></i></button>

                <button className="btn btn-lg btn-dark btn-block very-light-btn dr-padding p-relative-p shadow-none bg-white status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("invite-user")}><i class="fas fa-user-plus"></i> Invite User <i className="fas fa-angle-right profile-right-icon"></i></button>

                <button className="btn btn-lg btn-dark btn-block very-light-btn dr-padding p-relative-p shadow-none bg-white status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleSupportRequest()}><i class="fas fa-headphones"></i> Request Support <i className="fas fa-angle-right profile-right-icon"></i></button>

                <button className="btn btn-lg btn-dark btn-block very-light-btn dr-padding p-relative-p shadow-none bg-white status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("feedBack")}><i class="fas fa-comments"></i> Feedback <i className="fas fa-angle-right profile-right-icon"></i></button>
                {/* <button className="btn btn-md btn-dark btn-block very-light-btn status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("feedBack")}><i className="fas fa-comments"></i> Feedback <i className="fas fa-angle-right profile-right-icon"></i></button> */}
                {/* <button className="btn btn-md btn-dark btn-block very-light-btn status-font min-font-size text-left normal-demo-text rounded-pill" onClick={() => handleNavigation("tallyReg")}><i className="far fa-building"></i> My Tally Companies <i className="fas fa-angle-right profile-right-icon"></i></button> */}
              </div>
              {/* <hr className="hr-light-border"></hr>
                           <div className="text-center mb-3">
                              <button className="btn btn-md btn-dark btn-block very-light-btn status-font min-font-size text-left normal-demo-text rounded-pill" onClick={()=>handleNavigation("profile")}><i className="fas fa-cog"></i> Profile Settings <i className="fas fa-angle-right profile-right-icon"></i></button>
                              
                            </div>  */}
              <hr className="hr-light-border"></hr>
              <div className="mb-3 pl-4 pr-4">
                <button className="text-dec-none c-pointer shadow-none mb-0 btn btn-outline-dark border-radius-25 font-size-14 status-font" onClick={() => handleNavigation("logOut")}><i className="fas fa-sign-out-alt"></i> Logout</button>
              </div>
            </div>
          </CModalBody>
        </CModal>
      </div>
      {/* profile modal ends */}
      {showFeedBack && <UserFeedback />}
    </>
  )

}

export default TheHeaderDropdown